let products = [
  {
    FIELD1: 1,
    titleText: "1. Be the “HOW DOES SHE DO IT?” Poster Girl in 2021",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item01.jpg?v=141599751763803768211772549798",
    imageAltText: "article img",
    imageTextInfo1: "Reminder Binder® Perfect Planning Bundle",
    info: "(Limited Supply)",
    bodyText:
      "With this 2021-22 Reminder Binder® Perfect Planning Bundle that title will be yours. You’ve proven to keep it glued when 2020 unexpectedly shut down the world; imagine if you had an artillery of organizational tools by your side?  This bundle was created to prepare you for anything that the new year brings. Some features you’ll love about this brilliantly colorful, functional, easy-to-carry, hard cover planner: weekly, monthly & yearly views, lots of checklists, planner stickers, list of holidays & more! Each Reminder Binder comes packaged in a coordinating gift box – making it the perfect holiday gift! ",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/copy-of-gratefall-deals-perfect-planning-bundle-reminder-binder-desk-calendar-mini-weekly-planner-pad-mini-desktop-calendars",
  },
  {
    FIELD1: 2,
    titleText: "2. Doing this 5 Minutes a Day Will Change Your Life!",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item02.jpg?v=118229508910563618521772549798",
    imageAltText: "article img",
    imageTextInfo1: "Gratitude Finder® Bundle",
    info: "(Limited Supply)",
    bodyText:
      "This year made it easy to find everything that was, well, just wrong in the world. A gratitude journal will help retrain your brain to seek out & find the good!  Journaling about things for which you're grateful, especially now, will brighten your thoughts, your mood and your day! Available in (12) styles – including (3) NEW styles designed especially for boys – each Gratitude Finder® includes 52 non-dated weekly spreads so you can journal as frequently as you wish. This special Gratitude Bundle also includes 330 Grateful Heart Stickers, designed specifically to complement your Gratitude Finder®! This thoughtful gift sells fast at this amazing price, especially when you consider that giving the gift of a happy heart is priceless. Get yours while the best styles are still in stock!",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/gifts-of-organization-gratitude-finder-journals-with-165-stickers-9-styles",
  },
  {
    FIELD1: 3,
    titleText: "3. Stay On the Money Train",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item03.jpg?v=119732094718760917711772549798",
    imageAltText: "article img",
    imageTextInfo1: "Budget Binder™ & Accessories Kit",
    info: "(Limited Supply)",
    bodyText:
      "Most of us had a wake-up call this year when the financial floor fell out from under us. Best way to avoid an unexpected pitfall is to have a solid plan for your money, aka a budget. But what does that mean & who should do it? Whether you're managing your household finances, just venturing out on your own or running a small business, the Budget Binder™ is your comprehensive guidebook to walk you through how to stay on track, even when the world tries to derail you. The Budget Binder™ Bundle (say that 10 times fast!) includes all the tools you’ll need to help you whip your finances into shape in the new year. Your future self called and said that this is the perfect gift!  Get one for you and a budgeting buddy!",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/gifts-of-organization-financial-goals-bundle-budget-binder-financial-planner-goal-stickers-insert-strips",
  },
  {
    FIELD1: 4,
    titleText: "4. Don’t Judge this Based on Size Alone",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item04.jpg?v=145557701386304693271772549798",
    imageAltText: "article img",
    imageTextInfo1: "Pocket Notebooks Trio",
    info: "(Limited Supply)",
    bodyText:
      "The List It, Plan It, Doodle It Pocket Notebooks maybe be small, but BIG on usefulness! The notebooks measure 4.5” x 6” – just the right size to give you plenty of room to bullet journal, plan or doodle, yet small enough to take with you on the go! Each hardcover notebook has 52 sheets designed especially for each use. The List It notebook pages include colorful checkboxes to brighten up your To-Do list! The Plan It notebook pages give you space to map out projects, tasks notes & follow-ups. The Doodle It notebook pages are designed with a grid pattern for bullet journaling, hand calligraphy or drawing. No need to choose just one, this bundle includes ALL 3!  Dazzle your favorite paper-loving gal this holiday.",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/gifts-of-organization-all-new-pocket-notebooks-bundle-of-3-list-plan-doodle",
  },
  {
    FIELD1: 5,
    titleText: "5. Peeking Permitted for This Super Handy Gift Kit",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item05.jpg?v=159494421596538666771772549798",
    imageAltText: "article img",
    imageTextInfo1: "Peek at the Week® Power Couple",
    info: "(Limited Supply)",
    bodyText:
      "Weekly planning has a whole new meaning thanks to 2020. This Peek at the Week® Power Couple is the dynamic duo of TWO weekly planner pads to keep you on time and your head clear. They were designed to be placeholders for all the things swimming in your head. And when things change, you simply start a new sheet to keep things looking orderly. And sane. This bundle includes both the 8x10 Peek at the Week® to keep at your desk & a 4x8.5 Mini Peek at the Week® to take with you on the go. Each pad includes 52 non-dated weekly pages so you can use them every week or as needed, you choose! Stuff a stocking or stack in a ribbon-tied set for every Type A person you know!",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/gifts-of-organization-peek-at-the-week-weekly-planner-pad-set-of-two-checklists-priorities-dry-erase-backer-1",
  },
  {
    FIELD1: 6,
    titleText: "6. 250,000 Moms Can’t Be Wrong",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item06.jpg?v=119259979458506256721772549798",
    imageAltText: "article img",
    imageTextInfo1: "Mom Must-Have School Keepsake Kit",
    info: "(Limited Supply)",
    bodyText:
      "The mountain of memorabilia, the social “pressure” to post the cutest First Day photo and the mom guilt of commemorating everything about your kids’ school journey...as if we needed anything else to make us feel like a #momfail. This Class Keeper® Bundle is a real mother-saver!  Every mom gets to say “Buh-bye Bins!” and “Hello” to the most creatively compact memory keeper. Available in (2) color-coordinated Sets, this bundle includes a Class Keeper® School Memory Binder, deck of First/Last Day Photo Signs & School Sticker Sets. This bundle makes a GREAT gift for all the moms in your life! ",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/collections/7-gifts-of-organization-that-will-change-everything-about-2021/products/gifts-of-organization-mom-must-have-school-keepsake-kit-class-keeper-photo-prop-deck-school-stickers",
  },
  {
    FIELD1: 7,
    titleText: "7. Stickers, stickers and more stickers. And maybe a few more!",
    image: "//denisealbright.com/cdn/shop/t/40/assets/arti5_item07.jpg?v=61892398459451078181772549798",
    imageAltText: "article img",
    imageTextInfo1: "ALL the Stickers | 3760+ Stickers",
    info: "(Limited Supply)",
    bodyText:
      "As a kid we would get excited to get a sticker from the teacher for doing a good job. Heck, as adults we plaster social media with our “I Voted” stickers every couple of years! Clearly the love of stickers does not go away with age! With this ALL-the-Stickers Bundle not only will you rekindle your own childhood love for stickers but also share the joy with your own kids. This giant bundle includes 3,768 (no, that’s not a typo) brilliantly colorful & fun planner stickers from (8) unique sticker sets. Stuff mom’s stocking with something that will make her feel like the kid-on-Christmas-morn again!",
    ctaText: 'BUY NOW',
    ctaAltText: "button",
    href:
      "https://denisealbright.com/products/copy-of-all-the-stickers-bundle-eight-sticker-sets-includes-3760-stickers-fits-any-planner",
  }
];

products.forEach(product => {
    // target element to append to
    const container = document.getElementById('c-listicle')

    // container for listicle being created
    const component = document.createElement('div')
    component.className = 'm-box'

    // title
    const title = document.createElement('a')
    title.setAttribute('href', product.href) 
    title.setAttribute('target', "_blank")
    const titleContent = document.createTextNode(product.titleText)
    title.className = 'm-title'

    // image
    const imgLink = document.createElement('a')
    imgLink.setAttribute('href', product.href) 
    imgLink.setAttribute('target', "_blank")
    const image = document.createElement('img')
    image.setAttribute('src', product.image)
    image.setAttribute('alt', product.imageAltText)
    image.className = 'm-ctaImg'

    // row containing left and right columns under image
    const imageTextRow = document.createElement('div')
    imageTextRow.className = 'row'

    // left column of row under image
    const imageTextCol1 = document.createElement('div')
    imageTextCol1.className = 'col'
    const col1P = document.createElement('p')
    col1P.className = 'm-imgTextCol1'
    const col1TextA = document.createTextNode(product.imageTextInfo1)
    const col1TextBr = document.createElement('br')
    const col1TextB = document.createTextNode(product.info)

    // right column of row under image
    // const imageTextCol2 = document.createElement('div')
    // imageTextCol2.className = 'col'
    // const col2P = document.createElement('p')
    // col2P.className = 'm-imgTextCol2'
    // const col2Text = document.createTextNode(`From ${product.imageTextPrice}`)

    // line below the row under image
    const line = document.createElement('hr')
    line.className = 'm-line'

    // info under line
    // const info = document.createElement('div')
    // const infoContent = document.createTextNode(`(${product.info})`)

    // button
    const button = document.createElement('a')
    // const buttonContent = document.createTextNode(product.cta)
    button.setAttribute('href', product.href)
    button.setAttribute('target', "_blank")
    button.className = 'm-ctaBtn'
    // const btnImage = document.createElement('img')
    // btnImage.setAttribute('src', product.cta)
    // btnImage.setAttribute('alt', product.ctaAltText)
    // btnImage.className = 'm-ctaBtnImg'
    const btnText = document.createTextNode(product.ctaText)

    // main copy
    const text = document.createElement('div')
    const textContent = document.createTextNode(product.bodyText)
    text.className = 'm-text'

    // append
    component.appendChild(title)
    title.appendChild(titleContent)
    component.appendChild(imgLink)
    imgLink.appendChild(image)
    component.appendChild(imageTextRow)
    imageTextRow.appendChild(imageTextCol1)
    imageTextCol1.appendChild(col1P)
    col1P.appendChild(col1TextA)
    col1P.appendChild(col1TextBr)
    col1P.appendChild(col1TextB)
    // imageTextRow.appendChild(imageTextCol2)
    // imageTextCol2.appendChild(col2P)
    // col2P.appendChild(col2Text)
    component.appendChild(line)
    // component.appendChild(info)
    // info.appendChild(infoContent)
    component.appendChild(button)
    // button.appendChild(btnImage)
    button.appendChild(btnText)
    component.appendChild(text)
    text.appendChild(textContent)
    container.appendChild(component)
})
const date = new Date()
date.setDate(date.getDate() - 10)
const dateDay = date.getDate()
const dateMonth = date.getMonth()
const dateYear = date.getFullYear()
const day = date.getDay()
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'Nov.', 'December']
const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const output = `${days[day]} | ${months[dateMonth]} ${dateDay}, ${dateYear}`
const dateElement = document.getElementsByClassName('m-date')
const dateElementText = document.createTextNode(output.toUpperCase())
dateElement[0].appendChild(dateElementText)